import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';
import { OptionTreeViewService } from "../../../../common/variables/options-tree.service";
import { TranslateService } from "../../../../common/variables/translate-service";
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { CommonFormValidator } from "../../../../common/services/form-validation.service";
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'sen-app-psd-options',
  templateUrl: './psd-options.component.html',
  styleUrls: ['./psd-options.component.scss'],
  providers: [
    OptionTreeViewService
  ]
})
export class PsdOptionsComponent implements OnInit {
  @Output() options = new EventEmitter<any>();
  @Output() blob = new EventEmitter<any>();
  items: TreeviewItem[];
  values: number[];
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: false,
    hasCollapseExpand: false,
    decoupleChildFromParent: false
  });
  public form: FormGroup;
  buttonClass = 'mat-primary';
  fileToUpload: any;
  imageBlob: Blob;

  constructor(public option: OptionTreeViewService, public formGroup: FormBuilder, public global: GlobalVariableService, public translate: TranslateService) {
    this.form = formGroup.group({
      coverPhoto: ['', CommonFormValidator.checkFileType]
    })
  }

  ngOnInit(): void {
    this.items = this.option.getOptions(this.translate);
  }

  handlefileInput(file: FileList) {
    this.fileToUpload = file.item(0);
    let reader = new FileReader();
    reader.readAsDataURL(this.fileToUpload);
    reader.onload = (event: any) => {
      this.imageBlob = event.target.result;
      this.blob.emit(this.imageBlob);
    };
  }

  onSelectionChange(value: any): void {
    this.options.emit(value);
  }

}
